import { render, staticRenderFns } from "./AgregarNueva.vue?vue&type=template&id=35a59d56&"
import script from "./AgregarNueva.vue?vue&type=script&lang=js&"
export * from "./AgregarNueva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports